class DetailsTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = [...this.querySelectorAll('.tab')];
    this.select = this.querySelector('select');
    this.panels = [...this.querySelectorAll('.tabpanel')];
  }

  get selected() {
    return this.selected;
  }

  set selected(idx) {
    this.selectTab(idx);
    // Updated the element's selected attribute value when
    // backing property changes.
    this.setAttribute('selected', idx);
  }

  connectedCallback() {
    this.setAttribute('role', 'tablist');
    // Add aria role="tabpanel" to each content panel.
    this.tabs.forEach((tab) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('tabindex', 0);
      tab.addEventListener('click', this.onTitleClick.bind(this));
      tab.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    // Add aria role="tabpanel" to each content panel.
    this.panels.forEach((panel) => {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('tabindex', 0);
    });

    if (this.select) {
      this.select.addEventListener('change',  this.onTitleChange.bind(this));
    }

    this.selected = this.findFirstSelectedTab() || 0;
  }

  disconnectedCallback() {
    this.tabs.forEach((tab) => {
      tab.removeEventListener('click', this.onTitleClick);
      tab.removeEventListener('keydown', this.onKeyDown);
    })
    if (this.select) {
      this.select.removeEventListener('change',  this.onTitleChange);
    }
  }

  onTitleClick(e) {
    if (e.target.classList.contains('tab')) {
      this.selected = this.tabs.indexOf(e.target);
      e.target.focus();
    }
  }

  onTitleChange(e) {
    this.selected = e.target.selectedIndex;
  }

  onKeyDown(e) {
    switch (e.code) {
      case 'ArrowUp':
      case 'ArrowLeft':
        e.preventDefault();
        var idx = this.selected - 1;
        idx = idx < 0 ? this.tabs.length - 1 : idx;
        this.tabs[idx].click();
        break;
      case 'ArrowDown':
      case 'ArrowRight':
        e.preventDefault();
        var idx = this.selected + 1;
        this.tabs[idx % this.tabs.length].click();
        break;
      default:
        break;
    }
  }

  findFirstSelectedTab() {
    let selectedIdx;
    this.tabs.forEach((tab, i) => {
      tab.setAttribute('role', 'tab');
      // Allow users to declaratively select a tab
      // Highlight last tab which has the selected attribute.
      if (tab.hasAttribute('selected')) {
        selectedIdx = i;
      }
    });
    return selectedIdx;
  }

  selectTab(idx = null) {
    this.tabs.forEach((tab, i) => {
      const select = i === idx;
      tab.setAttribute('tabindex', select ? 0 : -1);
      tab.setAttribute('aria-selected', select);
      this.panels[i].setAttribute('aria-hidden', !select);
    });
  }
}

customElements.define('details-tabs', DetailsTabs);